module.exports = __webpack_public_path__ + "static/media/p3.51d6ec98.jpg";